import { render } from "./AdminEducationSections.vue?vue&type=template&id=2de00609&scoped=true&ts=true"
import script from "./AdminEducationSections.vue?vue&type=script&lang=ts"
export * from "./AdminEducationSections.vue?vue&type=script&lang=ts"

import "./AdminEducationSections.vue?vue&type=style&index=0&id=2de00609&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de00609"]])

export default __exports__